import { render, staticRenderFns } from "./bread-crumb.vue?vue&type=template&id=d64b0c76"
import script from "./bread-crumb.vue?vue&type=script&lang=js"
export * from "./bread-crumb.vue?vue&type=script&lang=js"
import style0 from "./bread-crumb.vue?vue&type=style&index=0&id=d64b0c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports